import HomepageTemplate from 'components/templates/HomepageTemplate';
import React from 'react';

const Homepage = () => {
    return <HomepageTemplate />;
};

export default Homepage;
